import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "trash-can-2, delete, remove, garbage, waste" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.09451 3.75H3C2.58579 3.75 2.25 4.08579 2.25 4.5C2.25 4.91421 2.58579 5.25 3 5.25H3.75V14.25C3.75 15.4926 4.75736 16.5 6 16.5H12C13.2426 16.5 14.25 15.4926 14.25 14.25V5.25H15C15.4142 5.25 15.75 4.91421 15.75 4.5C15.75 4.08579 15.4142 3.75 15 3.75H11.9055C11.5725 2.45608 10.3979 1.5 9 1.5C7.60212 1.5 6.42755 2.45608 6.09451 3.75ZM7.70067 3.75H10.2993C10.04 3.30165 9.55521 3 9 3C8.44479 3 7.96003 3.30165 7.70067 3.75ZM5.25 5.25V14.25C5.25 14.6642 5.58579 15 6 15H12C12.4142 15 12.75 14.6642 12.75 14.25V5.25H5.25ZM7.5 7.5C7.91421 7.5 8.25 7.83579 8.25 8.25V12C8.25 12.4142 7.91421 12.75 7.5 12.75C7.08579 12.75 6.75 12.4142 6.75 12V8.25C6.75 7.83579 7.08579 7.5 7.5 7.5ZM10.5 7.5C10.9142 7.5 11.25 7.83579 11.25 8.25V12C11.25 12.4142 10.9142 12.75 10.5 12.75C10.0858 12.75 9.75 12.4142 9.75 12V8.25C9.75 7.83579 10.0858 7.5 10.5 7.5Z",
    fill: "currentColor",
    "fill-opacity": "0.6157"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }